import { values } from './enums'

const _enum = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  fatal: 4
}

export const logSeverity = {
  enumName: 'LogSeverity',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/logSeverity.js